import React, { useState } from "react";
import { HeaderContainer, AppLinks, AppLink, AppBold, ModalOptions } from "./styles.js";
import IconMenu from "../Icons/IconMenu.js";
import useScreenSize from "../../Hooks/useScreenSize.js";
import { useNavigate } from "react-router-dom";
import { RoutesNames } from "../utils/routes.js";
// import CountrySelect from "../../forms/CountrySelect/index.js";

const Header = () => {
  const navigate = useNavigate();
  const { width } = useScreenSize();
  const [showOptionsBar, setShowOptionsBar] = useState(false);
  return (
    <HeaderContainer>
      {/* <CountrySelect /> */}
      {width <= 768 ? (
        <>
          <AppLinks style={{ justifyContent: "space-between" }}>
            <AppBold>VISITAS: 00000</AppBold>
            <AppLink noMedia onClick={() => setShowOptionsBar(!showOptionsBar)}>
              <IconMenu />
            </AppLink>
          </AppLinks>
          {showOptionsBar && (
            <ModalOptions>
              <AppLink onClick={() => navigate(RoutesNames.home)}>Inicio</AppLink>
              <AppLink>¿Quienes somos?</AppLink>
              <AppLink>Servicios</AppLink>
              <AppLink>Guía de atención</AppLink>
              <AppLink>Noticias</AppLink>
              <AppLink onClick={() => navigate(RoutesNames.login)}>Login</AppLink>
            </ModalOptions>
          )}
        </>
      ) : (
        <AppLinks>
          <AppLink onClick={() => navigate(RoutesNames.home)}>Inicio</AppLink>
          <AppLink>¿Quienes somos?</AppLink>
          <AppLink>Servicios</AppLink>
          <AppLink>Guía de atención</AppLink>
          <AppLink>Noticias</AppLink>
          <AppBold>VISITAS: 00000</AppBold>
          <AppLink onClick={() => navigate(RoutesNames.login)}>Login</AppLink>
        </AppLinks>
      )}
    </HeaderContainer>
  );
};

export default Header;
